import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Radar, Zap, Sparkles, Wallet, UserSearch, Radio,
  Hammer, Star, Bell, History, FlaskConical, Activity, Settings2, TerminalSquare,
} from "lucide-react";

const GROUPS = [
  {
    label: "Discover",
    items: [
      { to: "/", label: "Command Center", icon: LayoutDashboard, end: true, id: "command-center" },
      { to: "/new-pairs", label: "New Pairs", icon: Radar, id: "new-pairs" },
      { to: "/breakout-radar", label: "Breakout Radar", icon: Zap, id: "breakout-radar" },
      { to: "/narrative-radar", label: "Narrative Radar", icon: Sparkles, id: "narrative-radar" },
    ],
  },
  {
    label: "Wallet Intel",
    items: [
      { to: "/wallets", label: "Wallet Intelligence", icon: Wallet, id: "wallet-intelligence" },
      { to: "/wallet-tracker", label: "Wallet Tracker", icon: Radio, id: "wallet-tracker" },
      { to: "/dev-tracker", label: "Dev Tracker", icon: Hammer, id: "dev-tracker" },
    ],
  },
  {
    label: "Monitor",
    items: [
      { to: "/watchlists", label: "Watchlists", icon: Star, id: "watchlists" },
      { to: "/alerts", label: "Alerts", icon: Bell, id: "alerts" },
    ],
  },
  {
    label: "Research",
    items: [
      { to: "/historical-analytics", label: "Historical Analytics", icon: History, id: "historical-analytics" },
      { to: "/backtest-lab", label: "Backtest Lab", icon: FlaskConical, id: "backtest-lab" },
      { to: "/market-overview", label: "Market Overview", icon: Activity, id: "market-overview" },
      { to: "/settings", label: "Settings", icon: Settings2, id: "settings" },
    ],
  },
];

export default function Sidebar({ onNavigate }) {
  return (
    <aside className="flex h-full w-60 shrink-0 flex-col border-r border-slate-800/80 bg-void">
      <div className="flex items-center gap-2.5 px-5 py-4">
        <div className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-amber-500 to-amber-800 peanut-glow">
          <TerminalSquare className="h-5 w-5 text-amber-50" />
        </div>
        <div className="leading-none">
          <div className="font-display text-lg font-bold tracking-tight text-slate-50">
            Pnut<span className="text-amber-400">Scan</span>
          </div>
          <div className="mt-0.5 font-mono text-[9px] uppercase tracking-widest text-slate-500">
            Solana Intel Terminal
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 pb-6">
        {GROUPS.map((g) => (
          <div key={g.label} className="mb-4">
            <div className="px-3 pb-1.5 font-mono text-[9px] font-semibold uppercase tracking-widest text-slate-600">
              {g.label}
            </div>
            <div className="space-y-0.5">
              {g.items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.end}
                  onClick={onNavigate}
                  data-testid={`nav-${it.id}`}
                  className={({ isActive }) =>
                    `group flex items-center gap-2.5 rounded-md px-3 py-2 text-[13px] font-medium transition-colors ${
                      isActive
                        ? "bg-amber-500/10 text-amber-300 border border-amber-600/30"
                        : "border border-transparent text-slate-400 hover:bg-slate-800/50 hover:text-slate-100"
                    }`
                  }
                >
                  <it.icon className="h-4 w-4 shrink-0" />
                  {it.label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-slate-800/80 px-4 py-3">
        <p className="text-[10px] leading-relaxed text-slate-600">
          PnutScan provides evidence &amp; intelligence. Never trades. You make the final decision.
        </p>
      </div>
    </aside>
  );
}
